import Reveal from "@/components/base/Reveal";
import SectionHeader from "@/components/base/SectionHeader";
import { hotList, siteInfo } from "@/mocks/melons";

const DELTA_META: Record<string, { icon: string; cls: string }> = {
  up: { icon: "ri-arrow-up-line", cls: "text-accent-600" },
  down: { icon: "ri-arrow-down-line", cls: "text-primary-600" },
  new: { icon: "ri-sparkling-2-fill", cls: "text-secondary-700" },
};

export default function HotRank() {
  return (
    <section id="hot" className="bg-background-100/60">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeader
          eyebrow="今日热搜"
          eyebrowIcon="ri-fire-line"
          title="全网围观热度榜"
          desc="按实时讨论量与群众反应排序，热度数字与网民意向会随围观进展滚动刷新，榜单热度仅反映网友关注程度，不代表本站立场。"
          action={
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-foreground-600">
              <i className="ri-time-line text-foreground-500" /> 更新于 今日 20:30
            </span>
          }
        />

        <div className="mt-8 grid gap-6 lg:grid-cols-[1.6fr_1fr]">
          <Reveal>
            <ol className="divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200 bg-background-50 shadow-soft">
              {hotList.map((item) => {
                const delta = DELTA_META[item.delta];
                const top = item.id <= 3;
                return (
                  <li key={item.id} className="group flex items-center gap-4 px-4 py-3.5 transition-colors hover:bg-background-100 md:gap-5 md:px-5">
                    <span
                      className={`w-8 shrink-0 text-center font-heading text-2xl ${
                        item.id === 1
                          ? "text-accent-500"
                          : item.id === 2
                            ? "text-accent-400"
                            : item.id === 3
                              ? "text-secondary-600"
                              : "text-foreground-300"
                      }`}
                    >
                      {String(item.id).padStart(2, "0")}
                    </span>
                    <a href="#talk" className="min-w-0 flex-1">
                      <p className="truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-700 md:text-[15px]">
                        {item.title}
                      </p>
                      <p className="mt-0.5 flex flex-wrap items-center gap-2 text-xs text-foreground-600">
                        <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">
                          {item.tag}
                        </span>
                        {top && <span className="hidden whitespace-nowrap sm:inline">热度 {item.heat}</span>}
                      </p>
                    </a>
                    <div className="flex shrink-0 flex-col items-end gap-1">
                      <span className="flex items-center gap-1 text-xs text-foreground-800">
                        <i className="ri-chat-3-line text-foreground-400" /> {item.comments}
                      </span>
                      <span className={`flex items-center gap-1 text-xs ${delta.cls}`}>
                        <i className={delta.icon} />
                        {item.delta === "new" ? "新上榜" : item.delta === "up" ? "热度上升" : "热度回落"}
                      </span>
                    </div>
                  </li>
                );
              })}
            </ol>
          </Reveal>

          <Reveal delay={120}>
            <aside className="flex flex-col gap-5">
              <div className="rounded-2xl border border-primary-200 bg-primary-100/40 p-5">
                <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-600 px-3 py-1 text-xs font-medium text-background-50">
                  <i className="ri-edit-2-line" /> 小编速评
                </span>
                <p className="mt-3 text-sm leading-relaxed text-foreground-800">
                  本期榜首从开播追到大结局，讨论量一路走高。提醒一句：热度高≠已实锤，反转往往藏在你看不到的后半段。想听反转风向，记得蹲「焦点大瓜」。
                </p>
                <div className="mt-4 h-1.5 w-full overflow-hidden rounded-full bg-primary-200/70">
                  <div className="h-full w-[62%] rounded-full bg-accent-500" />
                </div>
                <p className="mt-2 text-xs text-foreground-600">本月大瓜整体热议进度 62%</p>
              </div>

              <div className="rounded-2xl border border-background-200 bg-background-50 p-5 shadow-soft">
                <p className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                  <i className="ri-voiceprint-line text-primary-600" /> 围观风向速览
                </p>
                <div className="mt-4 flex flex-col gap-3 text-sm text-foreground-800">
                  <div className="flex items-center justify-between">
                    <span className="flex items-center gap-2 text-foreground-700">
                      <i className="ri-arrow-up-line text-accent-600" /> 上升中的话题
                    </span>
                    <span className="font-heading text-lg text-accent-600">4</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="flex items-center gap-2 text-foreground-700">
                      <i className="ri-flashlight-line text-secondary-600" /> 等待反转
                    </span>
                    <span className="font-heading text-lg text-secondary-600">3</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="flex items-center gap-2 text-foreground-700">
                      <i className="ri-flag-line text-primary-600" /> 官方已回应
                    </span>
                    <span className="font-heading text-lg text-primary-600">2</span>
                  </div>
                </div>
                <a
                  href="#mood"
                  className="mt-5 flex items-center justify-between rounded-lg border border-background-300 bg-background-100 px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  看看大家的吃瓜态度
                  <i className="ri-arrow-right-line" />
                </a>
              </div>

              <div className="rounded-2xl bg-primary-600 p-5 text-background-50">
                <p className="font-heading text-xl leading-tight">想第一时间收到反转更新？</p>
                <p className="mt-1.5 text-sm text-primary-50/90">每天此刻共有 {siteInfo.hotComments} 条评论在此围观。来「网友热议」找同好。</p>
                <a href="#talk" className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-background-50 px-4 py-2 text-sm font-medium text-primary-700 transition-transform hover:-translate-y-0.5">
                  去评论区逛逛 <i className="ri-arrow-right-line" />
                </a>
              </div>
            </aside>
          </Reveal>
        </div>
      </div>
    </section>
  );
}